module.exports = __webpack_public_path__ + "static/media/recycle.0ac94a24.png";